module.exports = __webpack_public_path__ + "static/media/ir.4eca31ff.svg";